<template>
  <div>
    <div>
      <!-- Breadcrumbs with home icon and links to travel services page -->
      <ol
        class="breadcrumb container d-none d-md-flex"   
      >
        <li>
          <a href="https://www.trailfinders.com" class="has-icon icon-l text-dark">
            <i class="material-icons"></i>
            <span>Home</span>
          </a>
        </li>
        <li>
          <a href="https://www.trailfinders.com/travel-services" class="text-dark"
            >Travel Services</a
          >
        </li>
        <li>
          <a href="https://www.trailfinders.com/visas" class="text-dark"
            >Trailfinders Visa Service</a
          >
        </li>
        <li class="active">{{ imageHeader }}</li>
      </ol>
    </div>
    <!-- Load page top background image with title and summary-->
    <div class="app-hero-img">
      <b-img :src="imageUrl" alt="Trailfinders Visa Service"></b-img>

      <div class="d-flex justify-content-center">
        <div class="caption-centered position-absolute top-40 bg-dark bg-opacity-50 p-3 justify-content-center"
             style="border-radius:20px; max-width:550px; z-index:5">
          <div class="flex-column text-center text-light">
            <h1 class="text-light m-4">{{ imageHeader }}</h1>
            <h3 v-if="mobile===false && webpageSummary !=''" class="text-light fs-6" v-html="webpageSummary">
            </h3>
          </div>
        </div>
      </div>
    </div>

<!--      <div class="hero-img-caption">-->
<!--        <div class="caption-cell">-->
<!--          <div class="container caption-inner caption-inner-dark">-->
<!--            <h1 class="caption-inner-title">{{ imageHeader }}</h1>-->
<!--            <p v-if="mobile===false" class="mt-2" v-html="visaSummary"></p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <!-- Country Visa service title -->
    <section class="app-section">
<!--      <h1 class="section-heading my-3">-->
<!--      {{ imageHeader }}</h1>-->
<!--      <div class="mb-4" :style="getVisaProcessDetailsWidth()">-->
<!--        <b-card border-variant="light" class="text-left">-->
<!--      <p>other details here</p>-->
<!--        </b-card>-->
<!--      </div>-->
<!--    </section>-->
    <!-- Country Visa process details -->
    <b-row>
<!--      <b-col cols="12" xl="8">-->
        <div class="mb-4" :style="getVisaProcessDetailsWidth()">
          <b-card border-variant="light" class="text-left">

<!--            <div class="mt-0 mb-5">-->
<!--              <h4 class="text-center" >-->
<!--                For more information, call our visa experts on<br />-->
<!--                <span v-if="referer === 'UK'" style="color: #ffa409">020 7084 6506</span>-->
<!--                <span v-if="referer === 'IE'" style="color: #ffa409">01 881 4990</span>-->
<!--              </h4>-->
<!--            </div>-->

            <!-- If country is Cuba, button to access the Cuban Visa application page -->
            <div v-if="visaCountry === 'Cuba'">
              <!-- Apply Cuban Visa button -->
              <b-button block class="mb-4" @click="applyVisa()">APPLY HERE TO RECEIVE YOUR CUBAN TOURIST CARD WITHIN 72 HOURS</b-button>
              <!-- Alert message boxes when the checkboxes are unselected -->
              <b-alert class="mt-3 mb-3" :show="alertAgree" variant='danger' style="text-align:center">You must agree to the terms and conditions to continue</b-alert>
              <b-alert class="mt-3 mb-3" :show="alertNobooking" variant='danger' style="text-align:center">If you have booked your trip through Air Canada or Exodus then your supplier will issue your Cuban Tourist Card</b-alert>
              <!-- Checkboxes to agree terms and conditions -->
              <b-form-checkbox
                id="checkbox-agree"
                v-model="checkboxAgree"
                name="checkbox-agree"
                value="true"
                unchecked-value="false"
              >
                <p>I have read, understood and agree to the visa application process mentioned below</p>
              </b-form-checkbox>
              <b-form-checkbox
                id="checkbox-nobooking"
                v-model="checkboxNobooking"
                name="checkbox-nobooking"
                value="true"
                unchecked-value="false"
              >
                <p>I do <u>not</u> have a tour booked Exodus and I am not travelling on Air Canada</p>
              </b-form-checkbox>
            </div>
            <p class="mt-2" v-html="visaDetails"></p>
          </b-card>
        </div>
<!--      </b-col>-->
<!--      <b-col cols="6" md="4">-->
<!--        &lt;!&ndash; <div style="max-width: 15rem; margin-left: 5px"> &ndash;&gt;-->
<!--        <div style="max-width: 15rem; margin-left: 25px">-->
<!--          <div class="has-icon icon-r w-100">-->
<!--            <ul class="list-unstyled">-->
<!--              <li>-->
<!--                <span class="h4 text-strong">To Book Call</span>-->
<!--              </li>-->

<!--              <li class="m-0">-->
<!--                <span class="small text-muted"> Visa Service </span>-->
<!--                <br />-->
<!--                <span class="h4 text-strong" v-if="referer === 'UK'">-->
<!--                  <a href="tel:02070846506">02070846506</a>-->
<!--                </span>-->
<!--                <span class="h4 text-strong" v-if="referer === 'IE'">-->
<!--                  <a href="tel:018814990">018814990</a>-->
<!--                </span>-->
<!--              </li>-->
<!--            </ul>-->

<!--            <i class="material-icons icon-lg hidden-xs"></i><br />-->
<!--          </div>-->
<!--          <div v-if="mobile===false">-->
<!--            <p class="mt-4 mb-4">-->
<!--              <span class="text-strong text-success"-->
<!--                >{{ getCurrency() }}20pp OFF Visa Service Charges</span-->
<!--              >-->
<!--              when you book your travel with Trailfinders-->
<!--            </p>-->
<!--          </div>-->
<!--        </div>-->
<!--      </b-col>-->
      <div v-if="mobile===true">
        <p class="mt-4 mb-4" style="text-align:left; margin-left: 40px">
          <span class="text-strong text-success"
            >{{ getCurrency() }}20pp OFF Visa Service Charges</span
          >
          when you book your travel with Trailfinders
        </p>
      </div>
    </b-row>
    </section>
  </div>
</template>

<script>
import { getPageData, getVisaData, getVisaDetails } from "@/services/api.js";

export default {
  data() {
    return {
      meta: {
        loaded: true,
      },
      unid: null,
      mobile: window.innerWidth <= 768,
      title: "",
      visaDetails: "",
      visaSummary: "",
      webpageSummary: "",
      visaCountry: "",
      imageHeader: "",
      imageUrl: "",
      phoneNumber: "02070846506",
      referer: window.siteVar.referer,
      countries: [],
      checkboxAgree:false,
      alertAgree:false,
      checkboxNobooking:false,
      alertNobooking:false,
    };
  },
  created() {
    addEventListener("resize", () => {
      this.mobile = innerWidth <= 768;
    });
  },
  mounted() {
    this.meta.loaded = true;
    this.unid = this.$route.params.id;

    if (this.unid === undefined) {
      //When country visa pages are refreshed
      this.getPageData();
    } else {
      //When navigating from visas main page
      this.title = this.$route.params.title;
      this.getVisaData();
    }
    window.scrollTo(0,0); //scroll to top of page
  },

  methods: {
    async getVisaData() {
      const visaData = await getVisaData(window.siteVar.referer, this.unid);
      this.imageUrl = visaData.tf_image;
      this.imageHeader = visaData.Title;
      this.visaCountry = visaData.Country

      if(visaData.webpage_summary) {
        if(visaData.webpage_summary !=='') {
          this.webpageSummary = visaData.webpage_summary;
        }
      }

      this.visaSummary = visaData.summary.content[2].data;
      this.visaSummary = this.visaSummary.replace('size="1"', 'size="3"');
      this.visaSummary = this.visaSummary.replace(
        'color=3D"#2F2F2F"',
        'color="#ffffff"'
      );
      this.visaSummary = this.visaSummary.replace(/=\r\n/g, "");

      if (visaData) {
        this.getVisaDetails(visaData.Country);
      }
    },
    async getVisaDetails(country) {
      const visaDetails = await getVisaDetails(window.siteVar.referer, country);
      this.visaDetails = visaDetails;
      this.visaDetails = this.visaDetails.replace('size="2"', 'size="5"');
      this.meta.loaded = true;
      return visaDetails;
    },
    async getPageData() {
      const countriesData = await getPageData();

      this.countries = countriesData;
      if (this.countries.length > 0) {
        const result = this.countries.filter((item) => {
          return item.visa_code_link === this.$route.fullPath
        });
        this.unid = result[0]["@unid"]
        this.title = result[0]["$13"].split("^").pop()
        this.getVisaData()
      }
      this.meta.loaded = true;
    },
    getCurrency() {
      let currency = "£";
      if (this.getRegion()) {
        currency = window.siteVar.referer === "IE" ? "€" : currency;
      }
      return currency;
    },
    getRegion() {
      let region = "UK";
      if (window.siteVar.referer) {
        region = window.siteVar.referer;
      }
      return region;
    },
    applyVisa(){
      this.alertAgree = false
      this.alertNobooking = false
      if(!this.checkboxAgree){
        this.alertAgree = true
        return
      }
      if(!this.checkboxNobooking){
        this.alertNobooking = true
        return
      }
      const cubanVisaUrl = "https://www.trailfinders.com/visas/cuba#/cuban-visa-application"
      window.location.href = cubanVisaUrl;
    },
    getVisaProcessDetailsWidth() {
      return this.mobile ? "max-width: 30rem; margin:0 auto" : "max-width: 50rem;  margin:0 auto";
    }
  },
};
</script>